<template>
    <section class="section">
        <h1 class="level-item has-text-centered is-size-1">Jacob P. Dahl</h1>
        <p class="subtitle level-item has-text-centered">Curretly employed</p>
    </section>
</template>

<script>
export default {
    name: "HelloWorld",
    props: {
        msg: String,
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
